/**
 * Device Storage API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { FieldExistsFilterDefinition } from './fieldExistsFilterDefinition';


export interface LongRangeDeviceRequestDto { 
    airtimeNetworkStatusChangeRequestedFilter?: boolean;
    batteryTypeIdFilter?: Array<string>;
    comIdsFilter?: Array<string>;
    comTypeFilter?: Array<LongRangeDeviceRequestDto.ComTypeFilterEnum>;
    count?: number;
    customerContactFilter?: Array<string>;
    customerRefNoFilter?: Array<string>;
    dataPlanFilter?: Array<LongRangeDeviceRequestDto.DataPlanFilterEnum>;
    deviceIdsFilter?: Array<number>;
    deviceTypeIdFilter?: Array<string>;
    firmwareVersionIdFilter?: Array<string>;
    genericFieldExistsFilter?: Array<Array<FieldExistsFilterDefinition>>;
    gpsPlusDeviceFilter?: boolean;
    networkStatusFilter?: Array<LongRangeDeviceRequestDto.NetworkStatusFilterEnum>;
    orderBy?: string;
    orderDirection?: string;
    orderItemConfigurationIdFilter?: Array<string>;
    page?: number;
    parametersSet?: Array<string>;
    paymentAccountFilter?: Array<number>;
    pcbTypeIdFilter?: Array<string>;
    replacedByIdFilter?: Array<number>;
    rmaIdFilter?: Array<string>;
    shippingDateAfterFilter?: string;
    shippingDateBeforeFilter?: string;
    testDeviceFilter?: boolean;
    userSubsystemIdentifierVisibilityEnabled?: Array<number>;
}
export namespace LongRangeDeviceRequestDto {
    export const ComTypeFilterEnum = {
        Iridium: 'IRIDIUM',
        Globalstar: 'GLOBALSTAR',
        NbIot: 'NB_IOT',
        NoCommunication: 'NO_COMMUNICATION',
        Gsm: 'GSM'
    } as const;
    export type ComTypeFilterEnum = typeof ComTypeFilterEnum[keyof typeof ComTypeFilterEnum];
    export const DataPlanFilterEnum = {
        Unlimited: 'UNLIMITED',
        ThreeKbyte: 'THREE_KBYTE',
        SmithsonianSpecial: 'SMITHSONIAN_SPECIAL',
        PooledThreeKbyte: 'POOLED_THREE_KBYTE',
        PooledTwelveKbyte: 'POOLED_TWELVE_KBYTE',
        Test25Kbyte: 'TEST_2_5_KBYTE',
        Test4Kbyte: 'TEST_4_KBYTE'
    } as const;
    export type DataPlanFilterEnum = typeof DataPlanFilterEnum[keyof typeof DataPlanFilterEnum];
    export const NetworkStatusFilterEnum = {
        Activating: 'ACTIVATING',
        Activated: 'ACTIVATED',
        Deactivating: 'DEACTIVATING',
        Deactivated: 'DEACTIVATED',
        Suspending: 'SUSPENDING',
        Resuming: 'RESUMING',
        Changing: 'CHANGING',
        Invalid: 'INVALID',
        Changed: 'CHANGED'
    } as const;
    export type NetworkStatusFilterEnum = typeof NetworkStatusFilterEnum[keyof typeof NetworkStatusFilterEnum];
}


